<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" xl="2" sm="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    block
                    @click="changeAction(2)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left> mdi-plus </v-icon> Nuevo antecedente
                  </v-btn>
                </template>
                <span>Agregar antecedente</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con el búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.actions`]="{ item, index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="get(item, index)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="openDialogDelete(item, index)">
                    <v-icon color="error" v-bind="attrs" v-on="on">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)"/>
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col cols="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre"
                    rules="required|max:200"
                  >
                    <v-text-field
                      v-model="model.name"
                      :counter="200"
                      :error-messages="errors"
                      label="Nombre"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descripción"
                    rules="required|max:300"
                  >
                    <v-text-field
                      v-model="model.description"
                      :counter="200"
                      :error-messages="errors"
                      label="Descripción"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="3">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descripción"
                    rules="required|max:300"
                  >
                    <v-select
                      v-model="model.type"
                      :item-text="typesEvaluation.text"
                      :item-value="typesEvaluation.value"
                      :items="typesEvaluation"
                      :error-messages="errors"
                      label="Tipo"
                      required
                    ></v-select>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col align="right">
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    dark
                    color="success"
                    @click="pushQuestion()"
                  >
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider class="mt-10 mb-10" />
              <div v-if="!updating">
                <div
                  v-for="(question, index) in model.questions"
                  v-bind:key="index"
                >
                  <v-row align="baseline">
                    <v-col cols="4">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Pregunta"
                        rules="required|max:300"
                      >
                        <v-text-field
                          v-model="question.name"
                          :counter="300"
                          :error-messages="errors"
                          label="Pregunta"
                          required
                          autocomplete="off"
                        />
                      </validation-provider>
                    </v-col>
                    <v-col cols="3">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Tipo de pregunta"
                        rules="required|max:300"
                      >
                        <v-select
                          v-model="question.typeAnswer"
                          :item-text="typesAnswer.text"
                          :item-value="typesAnswer.value"
                          :items="typesAnswer"
                          :error-messages="errors"
                          label="Tipo de pregunta"
                          required
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>

                    <!-- {{question.typeData}} -->

                    <v-col
                      cols="2"
                      align="right"
                      v-if="question.typeAnswer == 1"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Tipo de respuesta"
                        rules="required|max:300"
                      >
                        <v-select
                          v-model="question.typeData"
                          :item-text="typesDataAnswer.text"
                          :item-value="typesDataAnswer.value"
                          :items="typesDataAnswer"
                          :error-messages="errors"
                          label="Tipo de respuesta"
                          dense
                          required
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="3">
                      <v-switch
                        v-model="question.required"
                        label="Requerida"
                        color="success"
                        :value="1"
                        hide-details
                      />
                    </v-col>

                    <v-row>
                      <v-col align="right">
                        <v-btn
                          class="mx-2"
                          @click="removeQuestion(index)"
                          fab
                          mdi-icon
                          x-small
                          light
                        >
                          <v-icon x-large color="red">mdi-delete-circle</v-icon>
                        </v-btn>
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          dark
                          color="cyan"
                          @click="pushAnswer(question)"
                          v-if="question.typeAnswer != 1"
                        >
                          <v-icon dark> mdi-plus </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ml-10 mt-5 mb-3 mr-3"
                      justify="center"
                      v-if="question.typeAnswer != 1"
                    >
                      <v-col
                        cols="3"
                        justify="center"
                        v-for="(answer, subindex) in question.answers"
                        v-bind:key="subindex"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Respuesta"
                          rules="required|max:300"
                        >
                          <v-text-field
                            v-model="answer.name"
                            :counter="300"
                            :error-messages="errors"
                            :label="subindex + 1 + ' Respuesta'"
                            required
                            autocomplete="off"
                          />
                        </validation-provider>
                        <v-btn
                          class="mx-2"
                          @click="removeAnswer(question, subindex)"
                          fab
                          mdi-icon
                          x-small
                          light
                        >
                          <v-icon x-large color="red">mdi-delete-circle</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-row>
                  <v-divider class="mt-10 mb-10" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <v-btn
                  type="button"
                  plain
                  color="error"
                  @click="changeAction(1)"
                >
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-btn
                  type="submit"
                  :disabled="invalid || sending"
                  color="success"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>

      <v-dialog v-model="dialogQuestion" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar la pregunta?
          </v-card-title>
          <v-card-text>
            <strong>Pregunta: </strong> {{ question.name }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogQuestion = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="deleteQuestion()">
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAnsware" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar la respuesta?
          </v-card-title>
          <v-card-text>
            <strong>Respuesta:</strong> {{ answer.name }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogAnsware = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="deleteAnswer()">
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEvaluation" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar el registro?
          </v-card-title>
          <v-card-text>
            <strong>Id: </strong> {{ evaluation.idEvaluation }} <br />
            <strong>Nombre: </strong> {{ evaluation.name }} <br />
            <strong>Descripción: </strong> {{ evaluation.description }} <br />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogEvaluation = false">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="deleteEvaluation()">
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { UtilFront } from "@/core/";

import { EvaluationRequest } from "@/core/request";

export default {
  name: "Antecedentes",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
  },
  data() {
    return {
      question: {},
      answer: {},
      dialogQuestion: false,
      dialogAnsware: false,
      dialogEvaluation: false,
      evaluation: {},
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: EvaluationRequest,
      search: "",
      headers: [
        { text: "Id Evaluación", value: "idEvaluation" },
        { text: "Tipo", value: "typeText" },
        { text: "Nombre", value: "name" },
        { text: "Descripción", value: "description" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      encabezado: {
        icono: "mdi-pencil-circle-outline",
        texto: "Antecedentes",
      },
      typesEvaluation: [
        { text: "Antecedentes no patológicos", value: 1 },
        { text: "Antecedentes patológicos", value: 2 },
        { text: "Antecedentes heredo familiares", value: 3 },
        { text: "Antecedentes gineco-obstétricos", value: 4 },
        { text: "Cita de psicología", value: 5 },
      ],
      typesAnswer: [
        { text: "Abierta", value: 1 },
        { text: "Cerrada", value: 2 },
        { text: "Multiple", value: 3 },
      ],
      typesDataAnswer: [
        { text: "Texto", value: 1 },
        { text: "Número", value: 2 },
        { text: "Correo", value: 3 },
        { text: "Fecha", value: 4 },
        { text: "Fecha con hora", value: 5 },
        { text: "Texto largo", value: 6 },
      ],
      updating: false,
    };
  },
  mounted() {
    this.listAll();
  },
  methods: {
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
        this.model = {};
        this.action = action;
        this.listAll();
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    listAll() {
      this.sending = true;
      this.service
        .listAll()
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.list = data;
          } else {
            this.list = [];
            this.$utilFront.notifications(
              "Sin resultados disponibles.",
              "WARNING"
            );
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    add() {
      if(!this.sending){
      this.sending = true;
      this.service
        .add(this.model)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha registrado correctamente.",
              "SUCCESS"
            );
            this.changeAction(1);
          } else {
            message = message || "Ocurrió un error durante el registro.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },
    update() {
      if(!this.sending){
      this.sending = true;
      this.service
        .update(this.model)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha modificado correctamente.",
              "SUCCESS"
            );
            this.changeAction(1);
            this.index = -1;
          } else {
            message = message || "Ocurrió un error durante la modificación.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
      }
    },
    get(item, i) {
      this.sending = true;
      this.model = Object.assign(this.model, item);
      this.index = Number(i);
      this.changeAction(3);
      this.sending = false;
      // this.service.get({idModule: id}).then((res) => {
      //   let { data, response, message } = res.data;
      //   if(response){
      //     this.model = data;
      //     this.index = Number(i);
      //     this.changeAction(3);
      //   }else{
      //     message = message || "Ocurrió un error al obtener la información.";
      //     this.$utilFront.notifications(message, "ERROR");
      //   }
      // }).catch(this.catchError).finally(()=>{this.sending = false;});
    },
    delete(id, i) {
      this.sending = true;
      this.service
        .delete({ id: id })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.list.splice(i, 1);
            this.$utilFront.notifications(
              "Se ha eliminado correctamente.",
              "SUCCESS"
            );
          } else {
            message = message || "Ocurrió un error al obtener la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },

    pushQuestion: function () {
      let data = {
        idQuestion: null,
        name: null,
        status: 1,
        typeAnswer: 1,
        typeAnswerText: "Abierta",
        orderQuestion: 1,
        required: 0,
        typeData: 1,
        typeDataText: "text",
        answer: null,
        idAnswer: null,
        answers: [],
        openAnswers: null,
        selectedAnswers: null,
      };
      this.updating = true;
      if (this.$utilFront.isEmptyList(this.model.questions)) {
        this.model.questions = [];
      }
      this.model.questions.push(data);
      this.updating = false;
    },
    pushAnswer(question) {
      let data = {
        idAnswer: null,
        name: "",
        status: 1,
        question: null,
        closedAnswers: null,
        selected: false,
      };
      this.updating = true;
      if (this.$utilFront.isEmptyList(question.answers)) {
        question.answers = [];
      }
      question.answers.push(data);
      this.updating = false;
    },
    removeQuestion(index) {
      if (this.action == 2 || this.model.questions[index].idQuestion == null) {
        this.updating = true;
        this.model.questions.splice(index, 1);
        this.updating = false;
      } else {
        this.index = index;
        this.question = this.model.questions[index];
        this.dialogQuestion = true;
      }
    },
    removeAnswer(question, index) {
      if (this.action == 2 || question.answers[index].idAnswer == null) {
        this.updating = true;
        question.answers.splice(index, 1);
        this.updating = false;
      } else {
        this.question = question;
        this.index = index;
        this.answer = question.answers[index];
        this.dialogAnsware = true;
      }
    },
    deleteQuestion() {
      this.dialogQuestion = false;
      this.sending = true;
      this.service
        .deleteQuestion({ idQuestion: this.question.idQuestion })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.updating = true;
            this.model.questions.splice(this.index, 1);
            this.updating = false;
            this.$utilFront.notifications(
              "Se ha eliminado correctamente.",
              "SUCCESS"
            );
          } else {
            message = message || "Ocurrió un error al eliminar la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    deleteAnswer() {
      this.dialogAnsware = false;
      this.sending = true;
      this.service
        .deleteAnswer({ idAnswer: this.answer.idAnswer })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.updating = true;
            this.question.answers.splice(this.index, 1);
            this.updating = false;
            this.$utilFront.notifications(
              "Se ha eliminado correctamente.",
              "SUCCESS"
            );
          } else {
            message = message || "Ocurrió un error al eliminar la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    deleteEvaluation() {
      this.dialogEvaluation = false;
      this.sending = true;
      this.service
        .deleteEvaluation({ idEvaluation: this.evaluation.idEvaluation })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.listAll();
            this.$utilFront.notifications(
              "Se ha eliminado correctamente.",
              "SUCCESS"
            );
          } else {
            message = message || "Ocurrió un error al eliminar la información.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    openDialogDelete(item, index) {
      this.evaluation = Object.assign(item, {});
      this.dialogEvaluation = true;
    },
  },
};
</script>
